import React from "react";
import PatientAction from "./patientActionButtons";
// Insurance Company:
// 		TPA:
// 		Card type:
// 		Package:
// 		CArd Holder Name:
// 		Relation with Patient:
const InsuranceInformation = () => {
    return (
        <><PatientAction />
        <form>
            <div className="row mt-3" style={{ marginLeft:0, marginRight: 0 }}>
                <div className="form-group col-md-6">
                    <label for="fname" className="control-label col-sm">Insurance Company</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="fname" placeholder="Insurance Company" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label for="lname" className="control-label col-sm">TPA</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="lname" placeholder="TPA" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label for="fname" className="control-label col-sm">Card type</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="fname" placeholder="Card type" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label for="lname" className="control-label col-sm">Package</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="lname" placeholder="Package" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label for="fname" className="control-label col-sm">CArd Holder Name</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="fname" placeholder="CArd Holder Name" />
                    </div>
                </div>
                <div className="form-group col-md-6">
                    <label for="lname" className="control-label col-sm">Relation with Patient</label>
                    <div className="col-sm">
                        <input type="text" className="form-control" id="lname" placeholder="Relation with Patient" />
                    </div>
                </div>
            </div>
        </form>
        </>
    );
};

export default InsuranceInformation; 